import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect, useRef } from "react";
import FormTextField from "../../components/formFields/FormTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closed } from "../../components/drawer/drawerSlice";
import { LoadingPanel } from "../../components/layout/Loading";
import {
  createPromoCode,
  findAllActivePromoCode,
  generatePromoCode,
  getAllPromoCodes,
  getPromoCodeById,
  updatePromoCode,
} from "./services/promocode.services";
import { clearPromoCodeDetails, clearPromoCodeID } from "./promocodeSlice";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import {
  DISC_TYPE,
  PROMO_TYPE,
  SECTOR_TYPE_FOR_COUPEN,
  STATUSARRAY,
} from "../../_contstants/common";
import FormRadioGroup from "../../components/formFields/FormRadioGroup";
import FormDatePicker from "../../components/formFields/FormDateField";
import moment from "moment";

interface TypeChangeWatcherProps {
  formRenderProps: FormRenderProps;
}

const TypeChangeWatcher: React.FC<TypeChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const dispatch = useAppDispatch();
  const PromoCodeID = useAppSelector((state) => state.drawer.data);
  const Type = formRenderProps.valueGetter("Type");

  useEffect(() => {
    const handlePromoCode = async () => {
      if (Type === "Auto" && !PromoCodeID) {
        const response = await dispatch(generatePromoCode());
        formRenderProps.onChange("PromoCode", { value: response.payload });
      }
    };

    handlePromoCode();
  }, [Type, dispatch]);

  return null;
};

const CratePromoCode: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  const PromoCodeDetail = useAppSelector(
    (state) => state.promocode.PromoCodeDetail
  );
  const PromoCodeID = useAppSelector((state) => state.drawer.data);
  const isIndirect = useAppSelector((state) => state.drawer.isIndirect);
  const formLoading = useAppSelector((state) => state.promocode.formLoading);
  // const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    return () => {
      dispatch(clearPromoCodeDetails());
      dispatch(clearPromoCodeID());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (PromoCodeID) {
      dispatch(getPromoCodeById(PromoCodeID));
    }
  }, [PromoCodeID]);

  const handleSubmit = async (values: any) => {
    try {
      if (!PromoCodeID) {
        const payload = {
          PromoCode: values?.PromoCode,
          FromDate: values?.FromDate
            ? moment(values?.FromDate).format("YYYY-MM-DD")
            : "",
          ToDate: values?.ToDate
            ? moment(values?.ToDate).format("YYYY-MM-DD")
            : "",
          DiscountType: values?.DiscountType,
          Value: values?.Value,
          MaxDiscount:
            values.DiscountType === "PER" ? values?.MaxDiscount : values?.Value,
          ApplyOn: values?.ApplyOn,
          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(createPromoCode(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearPromoCodeDetails());
          if (isIndirect) {
            dispatch(findAllActivePromoCode());
          } else {
            dispatch(getAllPromoCodes());
          }
        }
      } else {
        const payload = {
          ID: PromoCodeID,
          PromoCode: values?.PromoCode,
          FromDate: values?.FromDate
            ? moment(values?.FromDate).format("YYYY-MM-DD")
            : "",
          ToDate: values?.ToDate
            ? moment(values?.ToDate).format("YYYY-MM-DD")
            : "",
          DiscountType: values?.DiscountType,
          Value: values?.Value,
          MaxDiscount:
            values.DiscountType === "PER" ? values?.MaxDiscount : values?.Value,
          ApplyOn: values?.ApplyOn,
          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(updatePromoCode(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearPromoCodeDetails());
          dispatch(getAllPromoCodes());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <Form
      onSubmit={handleSubmit}
      // key={formKey}
      initialValues={PromoCodeDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              marginRight: 10,
            }}
            gap={{ rows: 10, cols: 10 }}
            cols={[{ width: "50%" }, { width: "50%" }]}
          >
            <GridLayoutItem className="master-drawer-header" colSpan={2}>
              <Typography.h4 className="m-0">
                {PromoCodeID ? "Update Promo Code" : "Create Promo Code"}
              </Typography.h4>
              <Button
                type="button"
                fillMode={"flat"}
                themeColor={"dark"}
                style={{ marginRight: 4 }}
                onClick={() => dispatch(closed())}
              >
                <RxCross1 />
              </Button>
            </GridLayoutItem>
            {!PromoCodeID && (
              <GridLayoutItem
                colSpan={2}
                className="flight-search-radio-griditem"
              >
                <Field
                  id={"Type"}
                  name={"Type"}
                  component={FormRadioGroup}
                  options={PROMO_TYPE}
                />
              </GridLayoutItem>
            )}

            <GridLayoutItem colSpan={1}>
              <Field
                name="PromoCode"
                label="Promo Code"
                component={FormTextField}
                placeholder="Promo Code"
                astrike={true}
                disabled={formRenderProps.valueGetter("Type") === "Auto" || PromoCodeID}
                validator={requiredValidator}
              />
            </GridLayoutItem>
            <GridLayoutItem colSpan={1}>
              <Field
                name={"ApplyOn"}
                label={"Apply On"}
                component={FormSelectionField}
                placeholder="Apply On"
                astrike={true}
                validator={requiredValidator}
                options={SECTOR_TYPE_FOR_COUPEN.map((type: any) => {
                  return {
                    value: type.value,
                    label: type.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem colSpan={1}>
              <Field
                id={"FromDate"}
                name={"FromDate"}
                component={FormDatePicker}
                label={"From Date"}
                validator={requiredValidator}
                minDate={moment().toDate()}
                onChange={(e) => {
                  if (
                    moment(e.value).isAfter(
                      moment(formRenderProps?.valueGetter("ToDate"))
                    )
                  ) {
                    formRenderProps.onChange("ToDate", { value: "" });
                  }
                }}
                astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem colSpan={1}>
              <Field
                id={"ToDate"}
                name={"ToDate"}
                component={FormDatePicker}
                label={"To Date"}
                minDate={
                  formRenderProps.valueGetter(`FromDate`)
                    ? moment(formRenderProps.valueGetter(`FromDate`)).toDate()
                    : moment().toDate()
                }
                validator={requiredValidator}
                astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem colSpan={1}>
              <Field
                name={"DiscountType"}
                label={"Discount Type"}
                component={FormSelectionField}
                placeholder="Discount Type"
                astrike={true}
                validator={requiredValidator}
                options={DISC_TYPE.map((type: any) => {
                  return {
                    value: type.value,
                    label: type.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem colSpan={1}>
              <Field
                name="Value"
                label="Value"
                component={FormTextField}
                placeholder="Value"
                astrike={true}
                type="number"
                validator={requiredValidator}
              />
            </GridLayoutItem>
            {formRenderProps.valueGetter("DiscountType") === "PER" && (
              <GridLayoutItem colSpan={1}>
                <Field
                  name="MaxDiscount"
                  label="Max Discount"
                  component={FormTextField}
                  placeholder="Max Discount"
                  astrike={true}
                  type="number"
                  validator={requiredValidator}
                />
              </GridLayoutItem>
            )}
            <GridLayoutItem colSpan={1}>
              <Field
                name="IsActive"
                label="Status"
                component={FormSelectionField}
                validator={requiredValidator}
                options={STATUSARRAY.map((type: any) => {
                  return {
                    value: type.value,
                    label: type.label,
                  };
                })}
                placeholder="Status"
                astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem
              colSpan={2}
              style={{
                textAlign: "end",
                marginTop: "10px",
                width: "100%",
              }}
            >
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginRight: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
              <ButtonWithLoading
                label={PromoCodeID ? "Update" : "Create"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
            </GridLayoutItem>
          </GridLayout>
          <TypeChangeWatcher formRenderProps={formRenderProps} />
        </FormElement>
      )}
    />
  );
};

export default CratePromoCode;
